import {Component, Input, OnInit} from '@angular/core';
import {CompactBuildingCard} from "./compact-building-card";
import {AddressFormatService} from "../../../common/services/address-format.service";
import {BuildingSummary} from "../../../common/model/building-summary";

@Component({
  selector: 'app-compact-building-card',
  templateUrl: './compact-building-card.component.html',
  styleUrls: ['./compact-building-card.component.css'],
})
export class CompactBuildingCardComponent {
  @Input()
  model: CompactBuildingCard;

  constructor(
    private addressFormatter: AddressFormatService,
  ){}

  public get building(): BuildingSummary {
    return this.model.building;
  }
  
  public get hasCover(): boolean {
    return !!this.building.multimedium?.url;
  }
  
  public get cover(): string {
    return this.building.multimedium.url;
  }
  public get multilineAddress(): string {
    return this.addressFormatter.formatToMultiline(this.building.address, true);
  }

}
